import React, { Component } from "react";
import { NavItem, Nav } from "react-bootstrap";

import { auth } from "firedb";

class HeaderLinks extends Component {
	render() {
		return (
			<div>
				<Nav>
					<NavItem eventKey={4} href="#">
						<i className="fa fa-dashboard" />
						<p className="hidden-lg hidden">Статистика</p>
					</NavItem>
				</Nav>

				<Nav pullRight>
					<NavItem eventKey={3} href="#" onClick={auth.doSignOut}>
						Log out
					</NavItem>
				</Nav>
			</div>
		);
	}
}

export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx